import React from "react";
import ReactDOM from "react-dom";
import RequestsPage from "./components/RequestsPage";

export function renderRequestsPage(props) {
  const target = document.getElementById("page-container");
  if (target) {
    ReactDOM.render(<RequestsPage {...props} />, target);
  }
}

export async function displayRequestsPage({ selectedTab }) {
  renderRequestsPage({ selectedTab });
}
